import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { Link, useNavigate, useParams } from "react-router-dom";
import Button from "react-bootstrap/Button";
import { useForm } from "react-hook-form";
import { region } from "../components/forms/adminForm";
import {
  checkEmailDuplication,
  checkPhoneDuplication,
  updatePartner,
} from "../../API/endpoints/Partner";
import ToastMessage from "../components/toasts/ToastMessage";

const PartnerServicePoc = (props: {
  regionList: region[];
  onContinue: (tab: string, status: boolean, data?: any) => void;
  partnerID?: string | "";
  data?: any;
  submitLoading?: boolean;
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setError,
    clearErrors,
  } = useForm({
    defaultValues: {
      first_name: "",
      last_name: "",
      designation: "",
      email: "",
      phone: "",
      contact_number_code: "+61",
    },
  });

  const [notification, setNotification] = useState({ type: "", msg: "" });
  const [selectedCCode, setSelectedCCode] = useState("");

  const params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (Object.keys(props.data).length > 0) {
      let phone = props?.data?.phone?.split(" ");
      const defaultValues = {
        first_name: props?.data?.first_name,
        last_name: props?.data?.last_name,
        designation: props?.data?.designation,
        email: props?.data?.email,
        phone: props?.data?.phone,
        contact_number_code: props?.data?.contact_number_code,
      };
      setSelectedCCode(props?.data?.contact_number_code);
      reset(defaultValues);
    }
  }, [props?.data]);

  const onSubmit = async (data: any) => {

    const req = {
      poc_firstname: data?.first_name,
      poc_lastname: data?.last_name,
      poc_designation: data?.designation,
      poc_email: data?.email,
      poc_countrycode: data?.contact_number_code,
      poc_phone: data?.phone,
    };
    if (params.partnerid) {
      onUpdatePocDetails(req, params.partnerid);
    } else {
      props.onContinue("poc", true, data);
    }
  };

  const onUpdatePocDetails = (data: any, partnerID: any) => {
    updatePartner(data, partnerID)
      .then(async (res) => {
        setNotification({
          type: "success",
          msg: "Updated successfully",
        });
        navigate(-1);
      })
      .catch((err) => {
        console.error("update error", err);
        setNotification({
          type: "error",
          msg: "Update failed !",
        });
      });
  };

  const handleCloseNotification = () =>
    setNotification({
      type: "",
      msg: "",
    });

  const onChangeEmail = async (value: string) => {
    const validEmail = new RegExp(
      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
    );

    if (value && validEmail.test(value)) {
      const req = {
        poc_email: value,
      };
      const res = await checkEmailDuplication(req);
      if (res) {
        if (res.msg === "Email already in use") {
          setError("email", { type: "manual", message: res.msg });
          return res.msg;
        }
        if (res.msg === "Email accepted") {
          clearErrors("email");
          return true;
        }
        return false;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const onChangePhone = async (value: string) => {
    if (value) {
      const req = {
        poc_phone: value,
      };
      const res = await checkPhoneDuplication(req);
      if (res) {
        if (res.msg === "Phone already in use") {
          setError("phone", { type: "manual", message: res.msg });
          return res.msg;
        }
        if (res.msg === "Phone accepted") {
          clearErrors("phone");
          return true;
        }
        return false;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  return (
    <Form
      onSubmit={
        handleSubmit((data) => {
          onSubmit(data);
        }, (err) => {
          console.error('err', err);
        })}
      className="mt40px"
    >
      <Container fluid>
        <Col sm={6} lg={6} xl={6}>
          <Row className="mb16px">
            <Col sm={6} lg={6} xl={6}>
              <Form.Group
                className="formgroup mr12px"
                controlId="formCompanyName"
              >
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter first name"
                  {...register("first_name", {
                    required: "* This field is required",
                    pattern: {
                      value:
                        /^(?=.*[a-zA-Z])[\w\d\s!@#$%^&*()-_=+`~[\]{}|;:'",<.>/?\\]*$/,
                      message:
                        "Only special characters or numbers are not allowed",
                    },
                  })}
                />

                <Form.Text muted>
                  <span>
                    <p className="error-form">{errors.first_name?.message}</p>
                  </span>
                </Form.Text>
              </Form.Group>
            </Col>
            <Col sm={6} lg={6} xl={6}>
              <Form.Group
                className="formgroup mr12px"
                controlId="formCompanyName"
              >
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter last name"
                  {...register("last_name", {
                    required: "* This field is required",
                    pattern: {
                      value:
                        /^(?=.*[a-zA-Z])[\w\d\s!@#$%^&*()-_=+`~[\]{}|;:'",<.>/?\\]*$/,
                      message:
                        "Only special characters or numbers are not allowed",
                    },
                  })}
                />

                <Form.Text muted>
                  <span>
                    <p className="error-form">{errors.last_name?.message}</p>
                  </span>
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb16px">
            <Col sm={6} lg={6} xl={6}>
              <Form.Group
                className="formgroup mr12px"
                controlId="formCompanyName"
              >
                <Form.Label>Designation</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter designation"
                  {...register("designation", {
                    required: "* This field is required",
                    pattern: {
                      value:
                        /^(?=.*[a-zA-Z])[\w\d\s!@#$%^&*()-_=+`~[\]{}|;:'",<.>/?\\]*$/,
                      message:
                        "Only special characters or numbers are not allowed",
                    }
                  })}
                />

                <Form.Text muted>
                  <span>
                    <p className="error-form">{errors.designation?.message}</p>
                  </span>
                </Form.Text>
              </Form.Group>
            </Col>
            <Col sm={6} md={6} lg={6}>
              <Form.Group className="formgroup" controlId="formEmail">
                <Form.Label>Email *</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="sample@mail.com"
                  {...register("email", {
                    required: "* This field is required",
                    pattern: {
                      value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                      message: "Invalid email address",
                    },
                    validate: async (value) => await onChangeEmail(value),
                  })}
                  // {...(errors.email && { error: true })}
                  onChange={(e) => onChangeEmail(e.target.value)}
                />
                <Form.Text muted>
                  <span>
                    <p className="error-form">{errors.email?.message}</p>
                  </span>
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb16px">
            <Col sm={6} md={6} lg={6}>
              <Form.Group className="formgroup" controlId="contact_number">
                <Form.Label>Phone</Form.Label>
                <InputGroup>
                  <Form.Select
                    style={{ maxWidth: "100px" }}
                    placeholder="Code"
                    {...register("contact_number_code", {
                      required: "* This field is required",
                    })}
                  >
                    {props?.regionList?.length &&
                      props?.regionList?.map((item: any) => {
                        return (
                          <option key={item.id} value={item.country_code}>
                            {item.country_code}
                          </option>
                        );
                      })}
                    <Form.Text muted>
                      <span>
                        <p className="error-form">
                          {errors.contact_number_code?.message}
                        </p>
                      </span>
                    </Form.Text>
                  </Form.Select>
                  <Form.Control
                    type="phone"
                    placeholder="Enter Phone number"
                    {...register("phone", {
                      required: "* This field is required",
                      pattern: {
                        value: /^[0-9]+$/,
                        message:
                          "Special characters or alphabets are not allowed",
                      },
                      validate: async (value) => await onChangePhone(value),
                      maxLength: {
                        value: 12,
                        message: "Maximum 12 digits allowed",
                      },
                    })}
                    //   {...register("contact_number", {
                    //     required: "* This field is required",
                    //   })}
                    {...(errors.email && { error: true })}
                    onChange={(e) => onChangePhone(e.target.value)}
                  />
                </InputGroup>
                <Form.Text muted>
                  <span>
                    <p className="error-form">{errors.phone?.message}</p>
                  </span>
                </Form.Text>
              </Form.Group>
            </Col>
          </Row>
        </Col>
      </Container>
      <Container fluid className="bt-gray200 mt40px">
        <Row className="justify-content-end mb-3 mt-4">
          <Col className="d-flex justify-content-end">
            <Link to="/PartnerManagement" className="m-1">
              <Button variant="secondary" className="btn-secondary12">
                Cancel
              </Button>
            </Link>
            {params.partnerid ? (
              <Button
                variant="primary"
                className="btn-primary12 m-1"
                type="submit"
              >
                Update
              </Button>
            ) : (
              <Button
                variant="primary"
                className="btn-primary12 m-1"
                type="submit"
                disabled={props?.submitLoading}
              >
                {props?.submitLoading ? "Saving..." : "Save and continue"}
              </Button>
            )}
          </Col>
        </Row>
      </Container>
      <ToastMessage
        notification={notification}
        onCancel={handleCloseNotification}
      />
    </Form>
  );
};

export default PartnerServicePoc;
